import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';

interface curso {
  id: string,
  titulo: string,
  instructorNombre: string,
  instructorId: string,
}

@Component({
  selector: 'app-resultado-cuestionario',
  templateUrl: './resultado-cuestionario.component.html',
  styleUrls: ['./resultado-cuestionario.component.css']
})
export class ResultadoCuestionarioComponent implements OnInit {

  // informacion entrante del cuestionario
  resultado: number;
  cursoId: string
  presentacionResultados: any;
  notas: any;
  verificacion: any;
  imagenes: any;
  curso: curso = {
    id: "",
    titulo: "",
    instructorNombre: "",
    instructorId: "",
  };

  // flahs para el front
  felicitaciones = false;
  intentaNuevamente = false;
  certificadoListo = false;

  constructor(
    private afAuth: AngularFireAuth,
    public authService: AuthService,
    private shared: RoutingVariablesService,
    private afs: AngularFirestore,
    private router: Router,
    private functions: AngularFireFunctions,
  ) { }

  usuario = JSON.parse(localStorage.getItem('user'))

  async ngOnInit() {
    this.resultado = +this.shared.recibirResultado().nota.toFixed(2);
    this.cursoId = this.shared.recibirResultado().cursoId;
    this.presentacionResultados = this.shared.recibirResultado().presentacionResultados;
    this.notas = this.shared.recibirResultado().notas;
    this.verificacion = this.shared.recibirResultado().verificacion;
    this.imagenes = this.shared.recibirResultado().imagenes;

    if (this.resultado >= 80) {
      this.felicitaciones = true
      this.cargarInfo();
    } else {
      this.intentaNuevamente = true;
    }
  }

  cargarInfo() {
    this.afs.collection("cursos").doc(this.cursoId).ref.get().then((snap) => {
      const data = snap.data();
      this.curso = {
        id: snap.id,
        instructorId: data["instructorId"],
        instructorNombre : data["instructorNombre"],
        titulo : data["titulo"],
      }
      this.generarCertificado();
    }).catch((error) => {
      console.log(error);
    })
  }

  generarCertificado() {
    const fechaCompletacion = Date();
    this.functions.httpsCallable("generarCertificado")({
      usuarioNombre: this.usuario.nombreCompleto,
      cursoId: this.curso.id,
      cursoTitulo: this.curso.titulo,
      instructorId: this.curso.instructorId,
      instructorNombre: this.curso.instructorNombre,
    }).toPromise().then(() => {
      this.certificadoListo = true
    }).catch(error => {
      console.log(error)
    })
  }

  descargarCertificado() {
    this.afs.collection('usuariosCertificados').ref.where('idCurso', '==', this.cursoId).where('idUsuario', '==', this.usuario.uid).get()
      .then(response => {
        response.docs.forEach(doc => {
          this.router.navigate(['/certificado', doc.id])
        })
      })
  }
}
